import { Component } from "@angular/core";
import { HeroComponent } from "./components/hero/hero.component";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-landing-page",
  standalone: true,
  imports: [HeroComponent, CommonModule],
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent {
  constructor(private router: Router) {}

  // component.ts
  solutions = [
    {
      id: "community",
      title: "Estate360 Community",
      description:
        "Estate360 Community empowers gated estates with visitor QR codes, a dedicated resident app, emergency alert buttons, and a manager dashboard — all designed to enhance safety, communication, and convenience for modern estate living.",
      imageUrl: "../../../assets/GIFS/community2.gif",
      imageAlt: "Estate360 Community Illustration",
      layout: "left",
    },
    {
      id: "homes",
      title: "Estate360 Homes",
      description:
        "Estate360 Homes connects buyers, sellers, and agents with verified property listings, in-app agent chat, and streamlined move-in logistics — making real estate transactions easier and more secure.",
      imageUrl:
        "https://placehold.co/700x450/2ECC71/FFFFFF?text=Estate360+Homes+Illustration",
      imageAlt: "Estate360 Homes Illustration",
      layout: "right",
    },
    {
      id: "developer",
      title: "Estate360 Developer",
      description:
        "Estate360 Developer equips estate builders and project teams with daily site updates, synchronized plot sales and construction tracking, and real-time workforce monitoring — all in one centralized platform.",
      imageUrl:
        "https://placehold.co/700x450/336799/FFFFFF?text=Estate360+Developer+Illustration",
      imageAlt: "Estate360 Developer Illustration",
      layout: "right",
    },
    {
      id: "organization",
      title: "Estate360 Organization",
      description:
        "Estate360 Organization offers role-based access, visitor scheduling, and seamless sync with estate security — built for offices, schools, and hospitals to streamline entry management and enhance safety across facilities.",
      imageUrl:
        "https://placehold.co/700x450/E67E22/FFFFFF?text= Estate360+Organization+Illustration",
      imageAlt: "Estate360 Organization Illustration",
      layout: "left",
    },
  ];

  productView(id: string) {
    this.router.navigate(["product-view", id]);
    console.log(id);
  }
}
